// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.map-drop-import-overlay {
    position: absolute;
    inset: 0;
    z-index: 100;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.25);
}

div.map-drop-import-overlay > span {
    background-color: var(--panel-bg-color);
    color: var(--panel-text-color);
    border: 2px dashed var(--panel-text-color);
    border-radius: 0.25em;
    padding: 1em 2em;
    font-size: large;
}
`, "",{"version":3,"sources":["webpack://./plugins/style/MapDropImport.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;IACvC,8BAA8B;IAC9B,0CAA0C;IAC1C,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":["div.map-drop-import-overlay {\n    position: absolute;\n    inset: 0;\n    z-index: 100;\n    pointer-events: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, 0.25);\n}\n\ndiv.map-drop-import-overlay > span {\n    background-color: var(--panel-bg-color);\n    color: var(--panel-text-color);\n    border: 2px dashed var(--panel-text-color);\n    border-radius: 0.25em;\n    padding: 1em 2em;\n    font-size: large;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
